import { render, staticRenderFns } from "./PhoneArea.vue?vue&type=template&id=456a5bba&"
import script from "./PhoneArea.vue?vue&type=script&lang=js&"
export * from "./PhoneArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports